import React from 'react';
import {api} from '../api';
import {storage} from '../helpers/storage.js';

export default function Login(props) {
  let login = e => {
    e.preventDefault();
    let username = document.getElementById('username').value;
    let pass = document.getElementById('password').value;

    api.login({username, pass})
      .then(response => {
        let user = {...response.data};
        storage.setItem('user', user);
        props.history.push('/projects');
      })
      .catch(err => {
        alert('Error');
      });

  }

  return (
    <div id="login">
      <form onSubmit={login}>
        <div className="input-field">
           <i className="material-icons prefix">account_circle</i>
           <input type="text" id="username"/>
           <label className="active">Username</label>
        </div>
        <div className="input-field">
           <i className="material-icons prefix">lock</i>
           <input type="password" id="password"/>
           <label className="active">Password</label>
        </div>
        <button type="submit" className="btn pink">Log in</button>
      </form>
    </div>
  )
}
